import moment from "moment";

export const humanizeDurationTime = (mint: string): any => {
  const mintInt = moment(mint);
  const now = moment(new Date());

  return moment.duration(now.diff(mintInt)).humanize();
};

export const getHourAndMintFromFBTimeStamp = (seconds) => {
  const _date = new Date(seconds * 1000);
  return (
    ("0" + _date.getHours()).slice(-2) +
    ":" +
    ("0" + _date.getMinutes()).slice(-2)
  );
};

export const getDateAndTimeFromFBTimeStamp = (seconds: number): string => {
  const _date = new Date(seconds * 1000);
  return (
    _date.toLocaleDateString() +
    " | " +
    _date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
};
